import reducer from './reducers'


export { default as taskOperations } from './operations'
export { default as taskTypes } from './types'

export default reducer